import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function Huelin() {
  return <NeighborhoodPageContent slug="huelin" />;
}